@let product = productDefinition();
@let shoppingCart = shoppingCartStore.shoppingCart;
@let corporateDesign = corporateDesignService.corporateDesign();
<aw-shopping-cart-headline
  [relationType]="ERelationType.shoppingCartLabel"></aw-shopping-cart-headline>
<aw-ticket-frame
  [hasHeadline]="true"
  [upperTicketElement]="upper"
  [upperSegments]="isMobile() ? [undefined] : currentTickets()"
  [styling]="{
    borderWidth: '1px',
    borderColor: corporateDesignService.primaryBorderColor(),
    backgroundColor: corporateDesignService.isDarkModeActive()
      ? corporateDesign.colorAdmixtures.dark_surface_01
      : 'white',
  }"
  [ngClass]="{
    'text-white': corporateDesignService.isDarkModeActive(),
  }">
  <ng-template #upper let-data="data" let-index="index">
    @if (isMobile()) {
      <div class="flex flex-row items-center">
        <div class="w-[1.625rem]">
          @if (mobileProductIndex() > 0) {
            <span
              class="material-symbols-rounded cursor-pointer !text-4xl"
              tabindex="0"
              (click)="previousProduct()"
              (keydown.enter)="previousProduct()"
              [attr.data-testid]="'shopping-cart-item-back'"
              >arrow_back_ios</span
            >
          }
        </div>
        <div class="w-full text-2xl">
          @let mobileProduct = currentTickets()[mobileProductIndex()];
          @if (mobileProduct) {
            <ng-container
              *ngTemplateOutlet="
                productInCart;
                context: {
                  index: index,
                  productForm: mobileProduct.productForm,
                  name: mobileProduct.productForm?.value?.tariffGroup?.name,
                  amount: mobileProduct?.productForm?.value?.amount ?? 0,
                  ticket: mobileProduct.ticket,
                  travelDate: mobileProduct?.productForm?.value?.travelDate,
                  attributes: (
                    mobileProduct?.productForm?.value?.selectionAttributes ?? []
                  ).concat(
                    mobileProduct?.productForm?.value?.productSortOptions ?? []
                  ),
                  productDefinition: mobileProduct.productForm?.value?.product,
                  owner: mobileProduct.owner,
                  companions: getCompanions(mobileProduct),
                }
              "></ng-container>
          }
        </div>
        <div class="w-[1.625rem]">
          @if (mobileProductIndex() < currentTickets().length - 1) {
            <span
              class="material-symbols-rounded cursor-pointer !text-4xl"
              tabindex="0"
              (click)="nextProduct()"
              (keydown.enter)="nextProduct()"
              [attr.data-testid]="'shopping-cart-item-forward'"
              >arrow_forward_ios</span
            >
          }
        </div>
      </div>
    } @else {
      <ng-container
        *ngTemplateOutlet="
          productInCart;
          context: {
            index: index,
            productForm: data.productForm,
            name: data.productForm?.value?.tariffGroup?.name,
            amount: data?.productForm?.value?.amount ?? 0,
            ticket: data.ticket,
            travelDate: data?.productForm?.value?.travelDate,
            attributes: (
              data?.productForm?.value?.selectionAttributes ?? []
            ).concat(data?.productForm?.value?.productSortOptions ?? []),
            productDefinition: data.productForm?.value?.product,
            owner: data.owner,
            companions: getCompanions(data),
          }
        "></ng-container>
    }
  </ng-template>
  <div lower>
    <div class="flex flex-col gap-4">
      @if (shoppingCartService.isCartTooFull) {
        <div class="text-input-error">
          {{
            textStore.texts()
              | filterTexts
                : ERelationType.maxAmountExceeded
                : EEntityType.shoppingCart
              | language
              | templateString
                : {
                    maxAmount: configurationStore
                      .getNumberConfiguration(
                        CONFIGURATION_SETTING_KEYS.MaxShoppingCartSize
                      )
                      .toString(),
                  }
          }}
        </div>
      }
      @if (currentTickets().length === 0) {
        <ng-container
          *ngTemplateOutlet="emptyShoppingCartTemplate"></ng-container>
      } @else {
        @if (!isOnLandingPage()) {
          <ng-container *ngTemplateOutlet="configurationButtons"></ng-container>
        } @else {
          <ng-container *ngTemplateOutlet="detailedPriceInfo"></ng-container>
          <ng-container
            *ngTemplateOutlet="continueConfiguration"></ng-container>
        }
      }
    </div>
  </div>
</aw-ticket-frame>
@if (isOnLandingPage() && currentTickets().length > 0) {
  <span
    tabindex="0"
    class="mt-[14px] flex cursor-pointer items-center justify-center gap-2"
    [id]="'empty-shopping-cart'"
    (keydown.enter)="emptyShoppingCart()"
    (click)="emptyShoppingCart()"
    [ngStyle]="{
      color: corporateDesignService.isDarkModeActive()
        ? corporateDesignService.corporateDesign().primaryDarkFontColor
        : corporateDesignService.corporateDesign().primaryFontColor,
    }">
    <span class="material-symbols-rounded icon-filled text-[24px]">
      delete
    </span>
    <span class="pt-1"
      >{{
        textStore.texts()
          | filterTexts: ERelationType.emptyCart : EEntityType.shoppingCart
          | language
      }}
    </span>
  </span>
}

<ng-template
  #productInCart
  let-index="index"
  let-productForm="productForm"
  let-ticket="ticket"
  let-name="name"
  let-amount="amount"
  let-attributes="attributes"
  let-travelDate="travelDate"
  let-owner="owner"
  let-companions="companions">
  @if (productForm) {
    <aw-direct-ticket-shopping-cart-item
      [positionInCart]="index"
      [productForm]="productForm"
      [ticket]="ticket"
      [ticketName]="name"
      [amount]="amount"
      [ticketAttributes]="attributes"
      [travelDate]="travelDate"
      [owner]="owner"
      [companions]="companions"
      [isTicketOwnerDataRequired]="
        isTicketOwnerDataRequired()
      "></aw-direct-ticket-shopping-cart-item>
  }
</ng-template>

<ng-template #configurationButtons>
  <aw-button
    [id]="'ticket-config-continue'"
    [type]="'button'"
    [style]="'secondary'"
    (click)="onButtonClick.emit()"
    [disabledText]="
      textStore.texts()
        | filterTexts
          : ERelationType.continueTicketConfigDisabled
          : EEntityType.generic
        | language
    "
    [isDisabled]="isDisabled() || shoppingCartService.isCartTooFull"
    >{{
      textStore.texts()
        | filterTexts: ERelationType.continueTicketConfig : EEntityType.generic
        | language
    }}</aw-button
  >
  <aw-button
    [id]="'ticket-config-into-cart'"
    [type]="'button'"
    [style]="'primary-alt'"
    [disabledText]="
      textStore.texts()
        | filterTexts
          : ERelationType.addToConfigurationDisabled
          : EEntityType.generic
        | language
    "
    [isDisabled]="isDisabled() || shoppingCartService.isCartTooFull"
    (click)="addAdditionalTicket()"
    >{{
      textStore.texts()
        | filterTexts: ERelationType.addToConfiguration : EEntityType.generic
        | language
    }}</aw-button
  >
</ng-template>

<ng-template #continueConfiguration>
  <aw-button
    [id]="'shopping-cart-continue'"
    [style.color]="'#000000'"
    [style]="'secondary'"
    (click)="proceedToPersonalData()"
    [type]="'button'"
    [text]="
      textStore.texts()
        | filterTexts
          : ERelationType.shoppingCartButtonContinueLabel
          : EEntityType.shoppingCart
        | language
    "></aw-button>
</ng-template>

<ng-template #emptyShoppingCartTemplate>
  <aw-shopping-cart-empty></aw-shopping-cart-empty>
</ng-template>

<ng-template #detailedPriceInfo>
  <div>
    @if (shoppingCart().showVat) {
      <div
        class="flex flex-col gap-3"
        [style.color]="
          corporateDesignService.secondaryDarkFontColor(
            corporateDesign.secondaryFontColor
          )
        ">
        <div class="flex justify-between">
          <div class="" [attr.data-testid]="'shopping-cart-netto-price-label'">
            {{
              textStore.texts()
                | filterTexts
                  : ERelationType.shoppingCartPriceNetLabel
                  : EEntityType.shoppingCart
                | language
            }}
          </div>
          <div class="" [attr.data-testid]="'shopping-cart-netto-price'">
            {{ totalNetPrice() | centsToEuros }}
          </div>
        </div>
        <div class="flex justify-between">
          <div [attr.data-testid]="'shopping-cart-gross-price-label'">
            {{
              textStore.texts()
                | filterTexts
                  : ERelationType.shoppingCartVatLabel
                  : EEntityType.shoppingCart
                | language
            }}
          </div>
          <div [attr.data-testid]="'shopping-cart-gross-price'">
            {{ totalVatPrice() | centsToEuros }}
          </div>
        </div>
        <div class="mb-3 border-b-1"></div>
      </div>
    }
    @if (product?.price?.priceIncludingVat) {
      <div class="flex flex-row justify-between pb-4">
        <div [attr.data-testid]="'shopping-cart-total-amount'">
          {{
            textStore.texts()
              | filterTexts: ERelationType.totalPrice : EEntityType.shoppingCart
              | language
          }}
          @if (totalTicketAmount() > 1) {
            ({{ totalTicketAmount() }}
            {{
              textStore.texts()
                | filterTexts: ERelationType.tickets : EEntityType.shoppingCart
                | language
            }})
          }
        </div>
        <div [attr.data-testid]="'shopping-cart-total-price'">
          {{ totalTicketPrice() | centsToEuros }}
        </div>
      </div>
    }
  </div>
</ng-template>
